// extracted by mini-css-extract-plugin
export default {"root":"gift_card_store_booking_checkout_page_root__9UN2m"};